import { useState, useCallback, useEffect } from "react";
import { Form } from "react-bootstrap";

import { EditButtons } from "../../utils/components/EditButtons";
import { formatCurrency, formatNumber } from "../../utils/functions";

export const Kondition = (props) => {
  const { kondition, editMode, readOnly, showEditButtons, disabled, error, changeKondition, handleEdit, handleUndo, handleCommit } = props || {};
  const [value, setValue] = useState(kondition ? Number(kondition.value) : 0);

  useEffect(() => {
    if (!editMode) {
      setValue(Number(kondition?.value || ""));
    }
  }, [editMode, kondition?.value]);

  const onKeyPress = useCallback((e) => {
    if (!e || e.key !== "Enter") return;
    // do not send Form on RETURN
    e.preventDefault();
    e.currentTarget.blur();
    return false;
  }, []);

  const onChange = useCallback((e) => {
    const target = e?.currentTarget || e?.target;
    if (!target) return;
    setValue(target.value === "" ? target.value : Number(target.value));
    if (!isNaN(target.value)) {
      changeKondition({ value: Number(target.value), col: kondition.col, kondition, invalid: !target.validity.valid });
    }
  }, [changeKondition, kondition]);

  const onBlur = useCallback((e) => {
    const target = e?.currentTarget || e?.target;
    if (!target) return;
    setValue(Number(kondition.value));
    target.value = Number(kondition.value);
  }, [kondition]);

  if (!kondition || isNaN(kondition.value)) return null;
  let dirty = kondition.editierbar && kondition.value !== kondition.originalWert;
  let min = kondition.isMaKond ? -5 : 0;
  let max = 10;
  let invalid = Number(value) < min || Number(value) > max || value === "" || !String(value).match(/^-?\d+(\.\d{1,2})?$/);
  let editButtons = typeof showEditButtons === "boolean" ? showEditButtons : true;
  if (readOnly) editButtons = false;

  return (
    <div className={(props.className || "") + " text-end"}>
      <Form.Group controlId={`kondition-${kondition.row}-${kondition.col}`} className="input-group">
        {editMode && !readOnly
          ? <>
            <Form.Label visuallyHidden="true">
              {kondition.label || "Kondition"}
            </Form.Label>
            <Form.Control
              className={"kondition text-end pt-0 pb-0"
                + (dirty ? " dirty mark" : "")
                + (invalid ? " is-invalid" : "")
              }
              maxLength="3"
              size="3"
              value={value}
              type="number"
              step=".01"
              min={min}
              max={max}
              required
              onChange={onChange}
              onBlur={onBlur}
              onKeyPress={onKeyPress}
            />
            <span className="input-group-text pt-0 pb-0">{kondition.einheit}</span>
          </>
          : <>
            <Form.Control
              disabled
              className={"text-end pt-0 pb-0 border-0 bg-transparent" + (dirty ? " dirty" : "")}
              type="text"
              value={kondition.einheit === "%"
                ? formatNumber(kondition.value / 100, { style: "percent", minimumFractionDigits: 1, })
                : formatCurrency(kondition.value)
              }
            />
          </>
        }
        {kondition.editierbar && editButtons
          ? <EditButtons
            editMode={editMode}
            disabled={disabled}
            handleEdit={handleEdit}
            handleUndo={handleUndo}
            handleCommit={handleCommit}
            invalid={invalid}
          />
          : null
        }
      </Form.Group>
      {error
        ? <div className="alert alert-danger fs-6 p-1">{error}</div>
        : null
      }
    </div>
  );
};
